import { useResourceList__ALPHA } from '@cube3/state/src/redux/components/Hooks/useResourceList';
import { BreadCrumbDataItem } from '../../BreadcrumbTrail/BreadCrumbTrail';
import { generatePath } from 'react-router-dom';
import { useMemo } from 'react';
import { urlStructureWorkspace } from '../../../routing/routingPaths';
import { useCurrentWorkspace } from '@cube3/state/src/redux/components/Administration/withCurrentWorkspace';
import { ResourceType } from '@cube3/state/types';

const emptyObj: any = {};
/** generate crumbs by a giving node id */
export const useFileRequestBreadcrumbs = (
  item: { type: ResourceType; nodeId: string; display_name?: string },
  includeParent = false // true if want to include the folder node itself in the breadcrumbs, so that the user navigates directly to the folder
) => {
  const [workspaceId] = useCurrentWorkspace();
  const baseURL = generatePath(urlStructureWorkspace, {
    workspaceId: workspaceId
  });

  const { type, nodeId, display_name } = item || emptyObj;

  const ancestors = useResourceList__ALPHA({
    resourceId: nodeId,
    resourceType: type,
    edgeType: nodeId ? 'folder' : undefined,
    edgeLabel: 'ancestors'
  });

  const crumbs: BreadCrumbDataItem[] = [];
  /*  check if the ancestor is the root library  */
  if (ancestors.resources && baseURL) {
    const isRootParentLibrary = baseURL.includes('library');

    ancestors.resources.length === 0
      ? crumbs.push({
          name: isRootParentLibrary ? 'Library' : 'Project',
          pathname: generatePath(baseURL)
        })
      : ancestors.resources.map((item, idx) => {
          const breadCrumb: BreadCrumbDataItem = {
            // itemType: 'folder', // since the ancestor is always a folder
            name: item.display_name,
            pathname:
              idx === 0 && isRootParentLibrary // prevent adding duplicate `Library` crumb
                ? baseURL
                : generatePath(baseURL + '/node/:nodeId', {
                    nodeId: item.id
                  })
          };
          return crumbs.push(breadCrumb);
        });
  }

  if (includeParent && type === 'folder') {
    crumbs.push({
      name: display_name,
      pathname: generatePath(baseURL + '/node/:nodeId', {
        nodeId: nodeId
      })
    });
  }

  return useMemo(
    () => ({
      crumbs,
      loading: ancestors.loading || !crumbs.length
    }),
    [crumbs, ancestors.loading]
  );
};
